import React from 'react'
import PortfolioContainer from '../components/Portfolio/PortfolioContainer'

const Porfolio = () => {
  return (
    <>
      <PortfolioContainer/>
    </>
  )
}

export default Porfolio